import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogAction,
  TagInput,
  useDialog,
  useToast,
  SelectInput,
  Button,
  Settings,
  Plus,
  DropdownMenu,
  Switch,
  Spinner,
  SwitchSelect,
} from "@repo/ui";

export const SharedComponents = () => {
  const { showToast } = useToast();
  const { showDialog } = useDialog();

  const [showAll, setShowAll] = useState(false);

  const [role, setRole] = useState("");
  const [error, setError] = useState("");

  const roles = [
    { value: "admin", label: "Administrator" },
    { value: "user", label: "User" },
    { value: "guest", label: "Guest" },
  ];

  const handleSubmit = () => {
    if (!role) {
      setError("Please select a role");
      return;
    }
    setError("");
    console.log("Selected:", role);
  };

  const handleClick = () => {
    showToast("success", "Welcome!", "Header", 100000);
  };

  const confirmCancel = () => {
    showDialog({
      title: "Confirm Cancel",
      description: "Are you sure you want to cancel?",
      confirmText: "Cancel",
      cancelText: "Go Back",
      onConfirm: async () => {
        console.log("Confirmed");
      },
      onCancel: () => {
        console.log("Cancelled");
      },
    });
  };

  return (
    <div className="">
      {/* Toast */}
      <button
        onClick={handleClick}
        className="w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
      >
        Show Welcome Toast
      </button>

      {/* MultiChoice Tag Input */}
      <TagInput />

      {/* Select Input */}
      <div>
        <SelectInput
          label="Role"
          options={roles}
          value={role}
          onChange={(val: string | string[] | undefined) => {
            setRole(val as string);
            setError("");
          }}
          error={error}
          required
        />
        <button onClick={handleSubmit}>Submit</button>
      </div>
      {/* Buttons */}
      <Button size="icon_md" icon={<Settings className="h-4 w-4" />} />
      <Button icon={<Settings className="h-4 w-4" />} variant="secondary">
        Settings
      </Button>
      <Button size="pill" variant="secondary" icon={<Plus className="h-4 w-4" />}>
        Add New
      </Button>

      {/* Loading Spinner */}
      <div className="flex items-center gap-2">
        <Spinner />
        <span>Loading...</span>
      </div>

      {/* Dropdown Menu */}
      <DropdownMenu
        items={[
          {
            id: "export",
            label: "Export",
            onClick: () => console.log("Export"),
          },
          {
            id: "settings",
            label: "Settings",
            icon: <Settings className="h-4 w-4" />,
            onClick: () => console.log("Settings"),
          },
        ]}
      />

      {/* Dialog */}
      <Dialog>
        <DialogAction openState={true}>
          <Button className="rounded bg-blue-600 px-4 py-2 text-white">Open</Button>
        </DialogAction>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Hello</DialogTitle>
            <DialogDescription>Custom dialog!</DialogDescription>
          </DialogHeader>
          <p>Content here</p>
          <DialogFooter>
            <DialogAction openState={false}>
              <button onClick={confirmCancel} className="rounded border px-4 py-2">
                Cancel
              </button>
            </DialogAction>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <div className="flex items-center gap-4">
        <label className="text-[15px] leading-none text-gray-900" htmlFor="airplane-mode">
          Airplane mode
        </label>
        <Switch
          id="airplane-mode"
          checked={showAll}
          onCheckedChange={setShowAll}
          className="data-[state=checked]:bg-gxe-primary bg-gray-300"
        />
        <SwitchSelect
          disabled={false}
          checked={showAll}
          onCheckedChange={setShowAll}
          labelClassName="mb-0 text-nowrap"
          containerClassName="flex items-center gap-2"
          label="Include"
        />
      </div>
    </div>
  );
};
